import { RouteRecordRaw } from 'vue-router'

const Branches = () =>
  import(/* webpackChunkName: "branches-view" */ './pages/index.vue')

const BranchesShow = () =>
  import(/* webpackChunkName: "branches-show" */ './pages/ShowPage.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'sucursales',
    name: 'branches',
    component: Branches,
    meta: {
      title: 'Sucursales',
      auth: {
        requiredPermission: 'branches.view',
        requiredModule: 'branches',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'sucursales/:ulid',
    name: 'branches-show',
    component: BranchesShow,
    meta: {
      title: 'Sucursal',
      auth: {
        requiredPermission: 'branches.view',
        requiredModule: 'branches',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
